/**
 * This fake function is used to initialize the serialization of BigInt values to a JSON format.
 */
export function initSerialization() {}

(BigInt.prototype as any).toJSON = function () {
    return Number(this);
};
